import includes from 'lodash/includes';
import buildingGray from 'images/hp-icons/building-gray.png';
import buildingTeal from 'images/hp-icons/building-teal.png';
import buildingRed from 'images/hp-icons/building-red.png';
import buildingYellow from 'images/hp-icons/building-yellow.png';
import houseGray from 'images/hp-icons/house-gray.png';
import houseTeal from 'images/hp-icons/house-teal.png';
import houseRed from 'images/hp-icons/house-red.png';
import houseYellow from 'images/hp-icons/house-yellow.png';
import roomGray from 'images/hp-icons/room-gray.png';
import roomTeal from 'images/hp-icons/room-teal.png';
import roomRed from 'images/hp-icons/room-red.png';
import roomYellow from 'images/hp-icons/room-yellow.png';
import type { IconBase, IconColor, IconResult, IconType, IconWithColor } from 'app/types/map.type';
import type { ListingDetails } from 'app/types/listingDetails.type';

// HPWEB-5163 - no longer distinction between buildings and condos on map

const building: IconBase = {
  size: { width: 22, height: 36 },
  scaledSize: { width: 22, height: 36 },
  anchor: { x: 22 / 2, y: 36 / 2 },
};

const house: IconBase = {
  size: { width: 22, height: 26 },
  scaledSize: { width: 22, height: 26 },
  anchor: { x: 22 / 2, y: 26 / 2 },
};

const room: IconBase = {
  size: { width: 31, height: 25 },
  scaledSize: { width: 31, height: 25 },
  anchor: { x: 31 / 2, y: 25 / 2 },
};

const iconsByIconType: Record<IconType, Record<IconColor, IconWithColor>> = {
  building: {
    red: { ...building, url: buildingRed, color: 'red' },
    gray: { ...building, url: buildingGray, color: 'gray' },
    yellow: { ...building, url: buildingYellow, color: 'yellow' },
    teal: { ...building, url: buildingTeal, color: 'teal' },
  },
  condo: {
    red: { ...building, url: buildingRed, color: 'red' },
    gray: { ...building, url: buildingGray, color: 'gray' },
    yellow: { ...building, url: buildingYellow, color: 'yellow' },
    teal: { ...building, url: buildingTeal, color: 'teal' },
  },
  house: {
    red: { ...house, url: houseRed, color: 'red' },
    gray: { ...house, url: houseGray, color: 'gray' },
    yellow: { ...house, url: houseYellow, color: 'yellow' },
    teal: { ...house, url: houseTeal, color: 'teal' },
  },
  room: {
    red: { ...room, url: roomRed, color: 'red' },
    gray: { ...room, url: roomGray, color: 'gray' },
    yellow: { ...room, url: roomYellow, color: 'yellow' },
    teal: { ...room, url: roomTeal, color: 'teal' },
  },
};

export function iconForListing(
  listing: Partial<ListingDetails> = {} as Partial<ListingDetails>,
  isActive = false,
  isDefault = false,
): IconResult {
  let { iconType = 'building' } = listing;
  const { listingType, userItemTypes } = listing;

  if (listingType === 'room') {
    iconType = listingType;
  }

  // Ensure we have a valid icon type
  const validIconType: IconType = (iconType in iconsByIconType ? iconType : 'building') as IconType;

  if (isDefault) {
    // Optional override for "default" red icon to display in things
    // mini-map or other areas. Overrides any icon color
    // normally determined by items found in listing.userItemTypes array.
    return iconsByIconType[validIconType].red;
  } else if (includes(userItemTypes, 'favorite')) {
    return iconsByIconType[validIconType].yellow;
  } else if (isActive) {
    return iconsByIconType[validIconType].teal;
  } else if (includes(userItemTypes, 'viewed')) {
    return iconsByIconType[validIconType].gray;
  } else {
    return iconsByIconType[validIconType].red;
  }
}
